import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCalendar, MatCalendarView } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import moment from 'moment';
import { ConversionDateTimeService } from 'src/app/core/services/conversion/conversion-datetime.service';

@Component({
  selector: 'app-date-picker-dialog',
  standalone: true,
  templateUrl: './date-picker-dialog.component.html',
  imports: [
    CommonModule,
    FormsModule,
    MatCalendar,
    MatIconModule,
    MatButtonModule,
  ],
})
export class DatePickerDialogComponent {
  selectedDate: Date;
  hour: number;
  minute: number;
  period: string | null = null; // Only used for 12-hour format
  is12HourFormat: boolean;
  isDaySelected = false;
  currentView: MatCalendarView = 'month';

  constructor(
    private dialogRef: MatDialogRef<DatePickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { selectedDate: string; minDate: Date; maxDate: Date },
    private conversionDateTimeService: ConversionDateTimeService,
  ) {
    // Determine the format preference

    const momentDate = moment(data.selectedDate);
    if (!momentDate.isValid()) {
      this.selectedDate = new Date();
    } else {
      this.selectedDate = momentDate.toDate();
    }
  }
  onViewChanged(view: MatCalendarView) {
    this.currentView = view;

    // If user is not in month view, they haven't picked a day yet
    if (view !== 'month') {
      this.isDaySelected = false;
    }
  }

  onDaySelected(date: Date | null) {
    if (!date) return;

    this.selectedDate = date;

    // Only valid if user is in day view
    if (this.currentView === 'month') {
      this.isDaySelected = true;
    }
  }

  confirmDateTime() {
    const momentDate = moment(this.selectedDate);
    this.dialogRef.close(momentDate.toDate());
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

  isValidDate(): boolean {
    if (!this.isDaySelected) return false;

    const selected = moment(this.selectedDate);

    if (!selected.isValid()) return false;

    if (this.data.minDate && selected.isBefore(this.data.minDate, 'day')) {
      return false;
    }

    if (this.data.maxDate && selected.isAfter(this.data.maxDate, 'day')) {
      return false;
    }

    return true;
  }
}
